import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import Button from '../../../button';
import {API_ROOT, APP_ID, APP_URL, authReturnUrl} from '../../../../utils';
import {getProfile} from '../../../../../actions/profileActions';
import Icon from '../../../icon';
import './index.css';

function GrantAccessTemplate () {

	const [isLoading, setIsLoading] = useState(false);

	const { t } = useTranslation();

	const profile = useSelector(state => state.profileReducer.getProfile);
	const dispatch = useDispatch();
	let timer = null;
	let profileInterval = null;

	useEffect(() => {
		return () => {
			clearTimeout(profileInterval);
		}
	}, [profileInterval]);

	const handleClick = () => {
		if(profile.isAdmin){
			let winRef = window.open('https://workspace.google.com/marketplace/dwi/' + APP_ID + '?redirect_url=' + APP_URL + '&authuser=' + profile.email, 'Popup', "width=800,height=600");
			setIsLoading(true);

			/*
			* Delay to detect the popup is closed
			* */

			timer = setInterval(function () {
				if(winRef.closed) {

					/*
					* Delay to let the eventual access changes to be applied to the Profile API
					* */

					profileInterval = setInterval(function () {
						dispatch(getProfile(true));
						setIsLoading(false);
					}, 5000);

					clearInterval(timer);

				}
			}, 5000);
		} else {
			window.location.href = API_ROOT + '/account/access-offline?authuser=' + profile.email + '&redirect=' + encodeURIComponent(authReturnUrl(window.location.pathname + window.location.search));
		}
	};

	return (
		<div className="container grant-access-template">
			{
				profile.isAdmin
				?
					<div className="grant-access-template__content">
						<h2>{t('grantAccessPageDomainUsersTitle')}</h2>
						<p>{t('grantAccessPageDomainUsersText')}</p>
						{
							isLoading
							?
								<Button className="btn-primary" disabled={true}>
									<Icon animated={'pulse'} name="spinner"/>
								</Button>
							:
								<Button onClick={ handleClick } className="btn-primary">{t('grantAccessPageDomainGrantBtn')}</Button>
						}

					</div>
				:
					<div className="grant-access-template__content">
						<h2>{t('grantAccessPageContactsTitle')}</h2>
						<p>{t('grantAccessPageContactsText')}</p>
						{
							isLoading
							?
								<Button className="btn-primary" disabled={true}>
									<Icon animated={'pulse'} name="spinner"/>
								</Button>
							:
								<Button onClick={ handleClick } className="btn-primary">{t('grantAccessPageContactsGrantBtn')}</Button>
						}
					</div>
			}

			<div className="grant-access-template__picture-wrapper">
				<img src="/img/grant-access-pic.png" alt=""/>
			</div>
		</div>
	)
}

export default GrantAccessTemplate;
